module.exports = __webpack_public_path__ + "img/corona2.66fd0333.jpeg";